module.exports = __webpack_public_path__ + "static/img/bg-pt.bab4ec97.png";